module.exports = __webpack_public_path__ + "img/couples_02_V.cc60894e.webp";